import React, { useState } from 'react';
import { ChevronDown, HelpCircle } from 'lucide-react';
import { useJsonLd } from '../services/seo';

// Public FAQ accordion + FAQPage JSON-LD for rich results
const FaqSection = ({ items, title = 'Questions fréquentes', testId = 'faq-section' }) => {
  const [open, setOpen] = useState(0);
  const valid = (items || []).filter(it => it.question && it.answer);
  useJsonLd(testId, valid.length ? {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: valid.map(it => ({ '@type': 'Question', name: it.question, acceptedAnswer: { '@type': 'Answer', text: it.answer } })),
  } : null);

  if (!valid.length) return null;
  return (
    <section className={`bg-white rounded-xl shadow-sm p-6 sm:p-8 ${testId === "home-faq" ? "" : "mt-6"}`} data-testid={testId}>
      <h2 className="text-xl font-bold text-gray-900 mb-4 flex items-center gap-2"><HelpCircle size={20} className="text-orange-500" /> {title}</h2>
      <div className="divide-y divide-gray-100">
        {valid.map((it, idx) => (
          <div key={idx} data-testid={`${testId}-item-${idx}`}>
            <button
              type="button"
              data-testid={`${testId}-question-${idx}`}
              onClick={() => setOpen(open === idx ? -1 : idx)}
              aria-expanded={open === idx}
              className="w-full flex items-center justify-between gap-4 py-3.5 text-left"
            >
              <span className="font-medium text-gray-900">{it.question}</span>
              <ChevronDown size={18} className={`text-gray-400 flex-shrink-0 transition-transform ${open === idx ? 'rotate-180' : ''}`} />
            </button>
            {open === idx && <p className="pb-4 text-gray-700 leading-relaxed text-sm sm:text-base" data-testid={`${testId}-answer-${idx}`}>{it.answer}</p>}
          </div>
        ))}
      </div>
    </section>
  );
};

export default FaqSection;
